import { VIDEOS } from "./data";
import { Reveal } from "./Reveal";

const VideoCard = ({ v }) => (
  <Reveal className={v.span}>
    <div
      data-testid={`project-${v.id}`}
      className={`group relative overflow-hidden border border-line bg-surface ${v.ratio}`}
    >
      <video
        src={v.src}
        poster={v.poster}
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/90 via-transparent to-ink/10" />
      <span className="absolute top-5 left-5 font-heading text-xs tracking-[0.2em] font-bold text-bone/70">
        {v.id}
      </span>
      <div className="absolute bottom-0 left-0 p-7 md:p-9">
        <p className="font-heading text-xs uppercase tracking-[0.25em] font-bold text-terracotta mb-2">
          {v.tag}
        </p>
        <h3 className="font-heading text-2xl md:text-3xl font-extrabold uppercase text-bone tracking-tight">
          {v.title}
        </h3>
      </div>
    </div>
  </Reveal>
);

export const Portfolio = () => {
  return (
    <section id="work" data-testid="portfolio-section" className="bg-ink py-24 md:py-40 border-t border-line">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end mb-16 md:mb-24">
          <Reveal className="md:col-span-8">
            <p className="font-heading text-xs uppercase tracking-[0.3em] font-bold text-terracotta mb-6">
              [ 03 ] — Selected work
            </p>
            <h2 className="font-heading font-extrabold uppercase text-bone tracking-tight leading-[0.9] text-4xl md:text-6xl lg:text-7xl">
              Real jobs, <br />
              <span className="text-stroke">real finishes</span>
            </h2>
          </Reveal>
          <Reveal className="md:col-span-4" delay={0.15}>
            <p className="font-body font-light text-stone text-base md:text-lg leading-relaxed">
              Footage from live MG Tiling Pro sites across Dublin — set-out, cuts,
              walls, floors and the finished result.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {VIDEOS.map((v) => (
            <VideoCard key={v.id} v={v} />
          ))}
        </div>
      </div>
    </section>
  );
};
